import {ApplicationConfig, importProvidersFrom, provideZoneChangeDetection} from '@angular/core';
import {InMemoryScrollingOptions, provideRouter, withInMemoryScrolling} from '@angular/router';

import {routes} from './app.routes';
import {provideClientHydration} from '@angular/platform-browser';
import {HTTP_INTERCEPTORS, provideHttpClient, withFetch, withInterceptors} from "@angular/common/http";
import {requestInterceptor} from "./interceptors/request/request.interceptor";
import {loaderInterceptor} from "./interceptors/loader/loader.interceptor";
import {httpErrorInterceptor} from "./interceptors/http-error/http-error.interceptor";
import {provideAnimationsAsync} from '@angular/platform-browser/animations/async';
import {MAT_SNACK_BAR_DEFAULT_OPTIONS} from "@angular/material/snack-bar";
import {IMAGE_LOADER, ImageLoaderConfig} from "@angular/common";
import {environment} from "../environments/environment";
import {AuthService} from "./auth/auth.service";
import {JwtModule, JwtModuleOptions} from "@auth0/angular-jwt";
import {apiKeyInterceptor} from "./interceptors/auth/api-key.interceptor";
import {authInterceptor} from "./interceptors/auth/auth.interceptor";

export const loaderImgPath = (config: ImageLoaderConfig): string => {
  const searchString = environment.localImagePath;
  const path = config.src;

  let imgPath = '';
  if (path.includes(searchString)) {
    imgPath = ` ${environment.hostName}/${path}`
  } else if (path.includes('uploads')) {
    imgPath = `${environment.backendUrl}${path}`
  } else {
    imgPath = `${environment.apiUrl}/${path}`
  }

  return imgPath;
}

export function tokenGetter() {
  return localStorage.getItem('token');
}

const jwtModuleOptions: JwtModuleOptions ={
  config: {
    tokenGetter: tokenGetter,
      allowedDomains: [environment.jwtAllowedDomains],
      disallowedRoutes: [environment.disallowedRoutes_1, environment.disallowedRoutes_2],
  }
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({eventCoalescing: true}),
    provideRouter(routes,
      withInMemoryScrolling({
        scrollPositionRestoration: "top",
      })),
    provideClientHydration(),
    provideAnimationsAsync(),
    provideHttpClient(
      withFetch(),
      withInterceptors([requestInterceptor, loaderInterceptor, httpErrorInterceptor, apiKeyInterceptor, authInterceptor])),
    importProvidersFrom(
      JwtModule.forRoot(jwtModuleOptions)
    ),
    {
      provide: IMAGE_LOADER,
      useValue: (config: ImageLoaderConfig) => {
        return loaderImgPath(config);
      }
    },
    {
      provide: MAT_SNACK_BAR_DEFAULT_OPTIONS, useValue: {
        duration: 5000,
        horizontalPosition: 'center',
        verticalPosition: 'top',
      }
    },
    AuthService,
    // {provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true}
  ]
};
